import { ThemeIcon } from '@mantine/core';
import { IconChecks, IconX } from '@tabler/icons-react';

type ReviewBooleanIconProps = {
  value?: boolean | null;
};

export const ReviewBooleanIcon = ({ value }: ReviewBooleanIconProps) => {
  if (value) {
    return (
      <ThemeIcon variant='transparent' color='green' size={24}>
        <IconChecks size={24} />
      </ThemeIcon>
    );
  }

  return (
    <ThemeIcon variant='transparent' color='red' size={24}>
      <IconX size={24} />
    </ThemeIcon>
  );
};
